import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CityDeliveryMap, PagedList } from '../interface';
import { DeliveryZoneModel, DeliveryZoneResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxDeliveryZoneService {
  constructor(
    private api: DeliveryZoneResourceService,
  ) {
  }

  getStoresCoordinatesByCityId(cityId: number, brandId: number, orderDate?: string): Promise<CityDeliveryMap> {
    return firstValueFrom(this.api.getZone(brandId, cityId, orderDate as any)) as unknown as Promise<CityDeliveryMap>;
  }

  getDeliveryZones(params: {
    page?: number;
    limit?: number;
    brandId?: number;
    cityId?: number;
    active?: boolean;
  }): Promise<PagedList<DeliveryZoneModel>> {
    return firstValueFrom(this.api.getDeliveryZones(params.active, params.brandId, params.cityId, params.limit, params.page)) as unknown as Promise<PagedList<DeliveryZoneModel>>;
  }

  getZoneById(id: number): Promise<DeliveryZoneModel> {
    return firstValueFrom(this.api.getDeliveryZoneById(id));
  }

  removeZoneById(id: number): Promise<void> {
    return firstValueFrom(this.api.removeDeliveryZone(id));
  }

  saveZone(zone: SaveZoneRequest): Promise<{ id: number }> {
    return firstValueFrom(this.api.saveDeliveryZone(zone as any)) as unknown as Promise<{ id: number }>;
  }
}

export interface SaveZoneRequest {
  id?: number;
  brandId: number;
  cityId: number;
  zone: CityDeliveryMap;
  fromDate: string;
}
